<script setup>
import PageSpeedTable from '@frontJs/components/tables/projectManagement/dev/PageSpeedTable.vue';
import TenantReportPageSpeedTable from '@frontJs/components/tables/projectManagement/dev/tenantReports/PageSpeedTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Temps de chargement - DEV - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - DEV - Temps de chargement
    </PageTitle>

    <PageSpeedTable v-if="tenant" :tenant="tenant" />
    <TenantReportPageSpeedTable v-else />
</template>
